module.exports = "<app-http-indicator></app-http-indicator>\r\n<app-notifications id=\"notifications\"></app-notifications>\r\n<router-outlet></router-outlet>"